import React, { Component } from 'react';
import { createStyles, withStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';



const styles = (theme) => createStyles({
  root: {
  },
  text: {
  },
});



class Heading extends Component {
  static defaultProps = {
    justifyContent: "center",
    variant: "h3",
    component: "h3",
    align: "center",
  }

  render() {
    const { classes, children, bgcolor, justifyContent, ...props } = this.props;

    return (
      <Box
        display="flex"
        classes={{ root: classes.root }}
        bgcolor={ bgcolor }
        justifyContent={ justifyContent }
        p={4}
        { ...props }
      >
        <Typography
          { ...this.props }
          classes={{ root: classes.text }}
        >
          { children }
        </Typography>
      </Box>
    );
  }

}

export default withStyles(styles)(Heading);
